import * as imageConversion from "image-conversion";
/**
 * 压缩图片
 * inputFile :file
 * toSize : 想要压缩的大小
 * */
export async function compressImage(inputFile, toSize) {
    const resAvatarBlob = await imageConversion.compressAccurately(
        inputFile,
        toSize
    );
    const resAvatarFile = new window.File([resAvatarBlob], inputFile.name, {
        type: inputFile.type,
    });
    resAvatarFile.uid = inputFile.uid;
    return resAvatarFile;
}